module.exports = __webpack_public_path__ + "img/begin_now.25edba5d.png";